export const elements = [
    	[1, "H","Hydrogen"       	],
    	[2, "He","Helium"        	],
    	[3, "Li","Lithium"       	],
    	[4, "Be","Beryllium"     	],
    	[5, "B","Boron"          	],
    	[6, "C","Carbon"         	],
    	[7, "N","Nitrogen"       	],
    	[8, "O","Oxygen"         	],
    	[9, "F","Fluorine"       	],
    	[10, "Ne","Neon"          	],
    	[11, "Na","Sodium"        	],
    	[12, "Mg","Magnesium"     	],
    	[13, "Al","Aluminium"     	],
    	[14, "Si","Silicon"       	],
    	[15, "P","Phosphorus"     	],
    	[16, "S","Sulphur"        	],
    	[17, "Cl","Chlorine"      	],
    	[18, "Ar","Argon"         	],
    	[19, "K","Potassium"      	],
    	[20, "Ca","Calcium"       	],
    	[21, "Sc","Scandium"      	],
    	[22, "Ti","Titanium"      	],
    	[23, "V","Vanadium"       	],
    	[24, "Cr","Chromium"      	],
    	[25, "Mn","Manganese"     	],
    	[26, "Fe","Iron"          	],
    	[27, "Co","Cobalt"        	],
    	[28, "Ni","Nickel"        	],
    	[29, "Cu","Copper"        	],
    	[30, "Zn","Zinc"          	],
    	[31, "Ga","Gallium"       	],
    	[32, "Ge","Germanium"     	],
    	[33, "As","Arsenic"       	],
    	[34, "Se","Selenium"      	],
    	[35, "Br","Bromine"       	],
    	[36, "Kr","Krypton"       	],
    	[37, "Rb","Rubidium"      	],
    	[38, "Sr","Strontium"     	],
    	[39, "Y","Yttrium"        	],
    	[40, "Zr","Zirconium"     	],
    	[41, "Nb","Niobium"       	],
    	[42, "Mo","Molybdenum"    	],
    	[43, "Tc","Technetium"      ],
    	[44, "Ru","Ruthenium"     	],
    	[45, "Rh","Rhodium"       	],
    	[46, "Pd","Palladium"     	],
    	[47, "Ag","Silver"        	],
    	[48, "Cd","Cadmium"       	],
    	[49, "In","Indium"        	],
    	[50, "Sn","Tin"           	],
    	[51, "Sb","Antimony"      	],
    	[52, "Te","Tellurium"     	],
    	[53, "I","Iodine"         	],
    	[54, "Xe","Xenon"         	],
    	[55, "Cs","Caesium"       	],
    	[56, "Ba","Barium"        	],
    	[57, "La","Lanthanum"     	],
    	[58, "Ce","Cerium"        	],
    	[59, "Pr","Praseodymium"  	],
    	[60, "Nd","Neodymium"     	],
    	[61, "Pm","Promethium"      ],
    	[62, "Sm","Samarium"      	],
    	[63, "Eu","Europium"      	],
    	[64, "Gd","Gadolinium"    	],
    	[65, "Tb","Terbium"       	],
    	[66, "Dy","Dysprosium"    	],
    	[67, "Ho","Holmium"       	],
    	[68, "Er","Erbium"        	],
    	[69, "Tm","Thulium"       	],
    	[70, "Yb","Ytterbium"     	],
    	[71, "Lu","Lutetium"      	],
    	[72, "Hf","Hafnium"       	],
    	[73, "Ta","Tantalum"      	],
    	[74, "W","Tungsten"       	],
    	[75, "Re","Rhenium"       	],
    	[76, "Os","Osmium"        	],
    	[77, "Ir","Iridium"       	],
    	[78, "Pt","Platinum"      	],
    	[79, "Au","Gold"          	],
    	[80, "Hg","Mercury"       	],
    	[81, "Tl","Thallium"      	],
    	[82, "Pb","Lead"          	],
    	[83, "Bi","Bismuth"       	],
    	[84, "Po","Polonium"        ],
    	[85, "At","Astatine"        ],
    	[86, "Rn","Radon"           ],
    	[87, "Fr","Francium"        ],
    	[88, "Ra","Radium"          ],
    	[89, "Ac","Actinium"        ],
    	[90, "Th","Thorium"         ],
    	[91, "Pa","Protactinium"    ],
    	[92, "U","Uranium"          ],
    	[93, "Np","Neptunium"       ],
    	[94, "Pu","Plutonium"       ],
    	[95, "Am","Americium"       ],
    	[96, "Cm","Curium"          ],
    	[97, "Bk","Berkelium"       ],
    	[98, "Cf","Californium"     ],
    	[99, "Es","Einsteinium"     ],
    	[100, "Fm","Fermium"        ],
    	[101, "Md","Mendelevium"    ],
    	[102, "No","Nobelium"       ],
    	[103, "Lr","Lawrencium"     ],
    	[104, "Rf","Rutherfordium"  ],
    	[105, "Db","Dubnium"        ],
    	[106, "Sg","Seaborgium"     ],
    	[107, "Bh","Bohrium"        ],
    	[108, "Hs","Hassium"        ],
    	[109, "Mt","Meitnerium"     ],
    	[110, "Ds","Darmstadtium"   ],
    	[111, "Rg","Roentgenium"    ],
    	[112, "Cn","Copernicium"    ],
    	[113, "Nh","Nihonium"       ],
    	[114, "Fl","Flerovium"      ],
    	[115, "Mc","Moscovium"      ],
    	[116, "Lv","Livermorium"    ],
    	[117, "Ts","Tennessine"     ],
    	[118, "Og","Oganesson"      ]
];

export const ions = [
    [		],
    [	1	],
    [		],
    [	1	],
    [	2	],
    [		],
    [		],
    [	-3	],
    [	-2	],
    [	-1	],
    [		],
    [	1	],
    [	2	],
    [	3	],
    [		],
    [	-3	],
    [	-2	],
    [	-1	],
    [		],
    [	1	],
    [	2	],
    [	3	],
    [	3,4	],
    [	3,5	],
    [	2,3	],
    [	2,4	],
    [	2,3	],
    [	2,3	],
    [	2,3	],
    [	1,2	],
    [	2	],
    [	3	],
    [	4	],
    [	-3	],
    [	-2	],
    [	-1	],
    [		],
    [	1	],
    [	2	],
    [	3	],
    [	4	],
    [	3,5	],
    [	6	],
    [	7	],
    [	3,4	],
    [	3	],
    [	2,4	],
    [	1	],
    [	2	],
    [	3	],
    [	2,4	],
    [	3,5	],
    [	-2	],
    [	-1	],
    [		],
    [	1	],
    [	2	],
    [	3	],
    [	3	],
    [	3	],
    [	3	],
    [	3	],
    [	2,3	],
    [	2,3	],
    [	3	],
    [	3	],
    [	3	],
    [	3	],
    [	3	],
    [	3	],
    [	3	],
    [	3	],
    [	4	],
    [	5	],
    [	6	],
    [	7	],
    [	4	],
    [	4	],
    [	2,4	],
    [	1,3	],
    [	2	],
    [	1,3	],
    [	2,4	],
    [	3,5	],
    [	2,4	],
    [	-1	],
    [		],
    [	1	],
    [	2	],
    [	3	],
    [	4	],
    [	4,5	],
    [	4,6	],
    [	5	],
    [	4	],
    [	3,4	],
    [	3	],
    [	3	],
    [	3	],
    [	3	],
    [	3	],
    [	2,3	],
    [	2,3	],
    [	3	],
    [		],
    [		],
    [		],
    [		],
    [		],
    [		],
    [		],
    [		],
    [		],
    [		],
    [		],
    [		],
    [		],
    [		],
    [		]
]



let current_max = 86; //118;
let current_tokenId = 5000;
while(elements.length > current_max){
    elements.pop();
}
while(ions.length > current_max + 1){
    ions.pop();
}


export let ion_names = [];
export let ion_list = [];

export let ion_total = current_max;


for(let i = 0; i < ions.length; i++){
    ion_names[i] =[];
    for(let j = 0; j < ions[i].length; j++){
        let ion = ions[i][j];
        if(ion < 0){
            ion = ion.toString();
        }else{
            ion = "+"+ion.toString();
        }

        ion_names[i].push(ion);
        if (!ion_list.includes(ion)) ion_list.push(ion);

    }
}
ion_list.sort((a,b)=>{
        return parseInt(a) < parseInt(b)?-1:1
    }
);

export let probabilities = {
    element:        {},
    ionCharge:      {},
    elementAndIon:  {},
    isIon:          0,
}

export function getProbability(atomicNumber,ionCharge,isIon,tokenId){
    if(isIon) return probabilities.isIon;
    if(atomicNumber > 0 && ionCharge === 0) return probabilities.element[atomicNumber];
    if(ionCharge > 0){
        ionCharge = "+"+ionCharge;
    } else{
        ionCharge = ionCharge.toString();
    }
    if(atomicNumber > 0) return probabilities.elementAndIon[atomicNumber][ionCharge];
    if(ionCharge !== '0') return probabilities.ionCharge[ionCharge];
    return 1;
}


function simulate_probabilities() {
    function fnv32a() {
        let str = JSON.stringify(arguments);
        let hval = 0x811c9dc5;
        for (let i = 0; i < str.length; ++i) {
            hval ^= str.charCodeAt(i);
            hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
        }
        return hval >>> 0;
    }

    
    function generationOf(_tokenId){
        return Math.floor(Math.log2(_tokenId));
    }
    function getAtomicNumber(tokenId,salt){
        if(parseInt(tokenId) === 1) return 0;
        const generation = generationOf(tokenId);
        let max;
        if(generation >= 13){
            max = 118
        }else if(generation >= 11){
            max = 86
        }else if(generation >= 9){
            max = 54
        }else if(generation >= 7){
            max = 36
        }else if(generation >= 5){
            max = 18
        }else if(generation >= 3){
            max = 10
        }else if(generation >= 1){
            max = 2
        }
        const r = salt/parseInt("ffffffffff",16);

        return Math.ceil(
            Math.pow(r,1+(generation>=8)*1)* max
        );
    }
    function getIon(atomicNumber,salt){
        return ions[atomicNumber].length === 0?0:1*(salt%3===0);
    }

    function getIonNum(atomicNumber,ion,salt){
        return ion===0?0:salt%ions[atomicNumber].length ;
    }

    let iterations = 100000;
    for(let i = 0; i < iterations; i++){
        let salt_atomicNumber = parseInt(fnv32a(i).toString()+fnv32a(i/2).toString())%parseInt("ffffffffff",16);

        let atomicNumber = getAtomicNumber(current_tokenId,salt_atomicNumber);
        let salt_ion0 = fnv32a(i/3)%256;
        let salt_ion1 = fnv32a(i/5)%256;
        let ion = 0;


        let ionise = getIon(atomicNumber,salt_ion0);
        let ionNum =   getIonNum(atomicNumber,ionise,salt_ion1);
        if(ionise !== 0){
            ion = ions[atomicNumber][ionNum];
        }
        let ion_name = ion.toString();
        if(ion > 0){
            ion_name = "+"+ion_name;
        }

        if(!probabilities.element[atomicNumber]){
            probabilities.element[atomicNumber] = 0;
        }
        probabilities.element[atomicNumber]++;

        if(!probabilities.ionCharge[ion_name]){
            probabilities.ionCharge[ion_name] = 0;
        }
        probabilities.ionCharge[ion_name]++;

        if(!probabilities.elementAndIon[atomicNumber]){
            probabilities.elementAndIon[atomicNumber] = {};
        }
        if(!probabilities.elementAndIon[atomicNumber][ion_name]){
            probabilities.elementAndIon[atomicNumber][ion_name] = 0;
        }
        probabilities.elementAndIon[atomicNumber][ion_name]++;

        if(ion !== 0){
            probabilities.isIon++;
        }
    }

    for(let e in probabilities.element){
        probabilities.element[e] /= iterations;
    }
    for(let e in probabilities.ionCharge){
        probabilities.ionCharge[e] /= iterations;
    }
    for(let e in probabilities.elementAndIon){
        for(let f in probabilities.elementAndIon[e]){
            probabilities.elementAndIon[e][f] /= iterations;
        }
    }
    probabilities.isIon /= iterations;

}
simulate_probabilities();

